import { TopBarProps } from './TopBar.types';
import ChevronLeft from '../../assets/chevron-left.svg?react';
import './TopBar.scss';
import { Input } from '../Input/Input';
import { useEffect, useState } from 'react';
export const TopBar: React.FC<TopBarProps> = ({ children, onBackClick, title, onSearch }) => {
  const [searchValue, setSearchValue] = useState<string>('');

  //Hook to check if the parent location has changed and reset or fill respectively
  //e.g. /user/ -> /user/edit and back to user is persited, /user/ -> /project/ is resetted
  useEffect(() => {
    const entry: string | null = localStorage.getItem('headerFilter');
    if (!entry || location.pathname.split('/')[2] === 'edit') return;
    const path: string = entry.split(',')[0];
    const value: string = entry.split(',')[1];
    let locationPath: string = location.pathname.split('/')[1];
    if (locationPath === 'inventory') {
      locationPath += location.pathname.split('/')[2];
    }
    if (path === locationPath) {
      onSearch && onSearch(value);
      setSearchValue(value);
    } else {
      localStorage.removeItem('headerFilter');
      setSearchValue('');
      onSearch && onSearch('');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  //Hook to update the filter in the localStorage
  useEffect(() => {
    if (location.pathname.split('/')[2] === 'edit') return;
    let path: string = location.pathname.split('/')[1];
    if (path === 'inventory') {
      path += location.pathname.split('/')[2];
    }
    if (searchValue) localStorage.setItem('headerFilter', path + ',' + searchValue);
    else localStorage.removeItem('headerFilter');
  }, [searchValue]);

  return (
    <div className="top-bar__wrapper">
      {onBackClick && (
        <div className="top-bar__chevron" onClick={() => onBackClick()}>
          <ChevronLeft className="top-bar__chevron__icon" />
        </div>
      )}
      {title && <h1 className="top-bar__wrapper__title">{title}</h1>}

      {(children || onSearch) && (
        <div className="top-bar__children">
          {children}
          {onSearch && (
            <Input
              type="text"
              onChange={(value) => {
                setSearchValue(value);
                onSearch(value);
              }}
              value={searchValue}
              maxWidth={350}
            />
          )}
        </div>
      )}
    </div>
  );
};
